import React, { FC } from 'react';

const HomePage: FC = () => <></>;

export default HomePage;
